import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  // Create a signal to track the online/offline status
  public connected = signal(window.navigator.onLine);

  constructor() {
    this.init();
  }

  private init(): void {
    // Listen for 'online' and 'offline' events and update the signal accordingly
    window.addEventListener('online', () => this.connected.set(true));
    window.addEventListener('offline', () => this.connected.set(false));
  }
}
